import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import MyStreamWaveMyVoteVotes from "./MyStreamWaveMyVoteVotes";
import MyStreamWaveMyVoteInput from "./MyStreamWaveMyVoteInput";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { SingleWaveDropPosition } from "@/components/waves/drop/SingleWaveDropPosition";
import { cicToType } from "@/helpers/Helpers";
import Link from "next/link";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ImageScale } from "@/helpers/image.helpers";
interface MyStreamWaveMyVoteProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly isChecked?: boolean;
  readonly onToggleCheck?: (dropId: string) => void;
  readonly isResetting?: boolean;
}
const MyStreamWaveMyVote: React.FC<MyStreamWaveMyVoteProps> = t0 => {
  const $ = _c(76);
  const {
    drop,
    onDropClick,
    isChecked: t1,
    onToggleCheck,
    isResetting: t2
  } = t0;
  const isChecked = t1 === undefined ? false : t1;
  const isResetting = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== drop.parts) {
    t3 = drop.parts.at(0)?.media.at(0);
    $[0] = drop.parts;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const artWork = t3;
  const t4 = drop.author.cic || 0;
  let t5;
  if ($[2] !== t4) {
    t5 = cicToType(t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const cicType = t5;
  let t6;
  if ($[4] !== drop || $[5] !== onDropClick) {
    t6 = () => {
      if (window.getSelection()?.toString()) {
        return;
      }
      onDropClick(drop);
    };
    $[4] = drop;
    $[5] = onDropClick;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const handleClick = t6;
  let t7;
  if ($[7] !== drop.id || $[8] !== onToggleCheck) {
    t7 = e => {
      e.stopPropagation();
      if (onToggleCheck) {
        onToggleCheck(drop.id);
      }
    };
    $[7] = drop.id;
    $[8] = onToggleCheck;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleCheckboxClick = t7;
  const t8 = `tw-bg-iron-950 tw-rounded-xl tw-px-5 tw-py-4 tw-border tw-border-solid tw-transition-all tw-duration-300 tw-cursor-pointer tw-shadow-md desktop-hover:hover:tw-shadow-lg tw-@container ${isChecked ? "tw-border-primary-400" : "tw-border-iron-800 desktop-hover:hover:tw-border-iron-700"}`;
  const t9 = `tw-size-5 tw-flex tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-solid ${isChecked ? "tw-border-primary-400 tw-bg-primary-400/20" : "tw-border-iron-600 tw-bg-iron-800"} tw-cursor-pointer tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-200`;
  let t10;
  if ($[10] !== isChecked) {
    t10 = isChecked && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="tw-size-4 tw-text-primary-400"><path fillRule="evenodd" d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 0 1 1.04-.208Z" clipRule="evenodd" /></svg>;
    $[10] = isChecked;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t9) {
    t11 = <div className={t9}>{t10}</div>;
    $[12] = t10;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== handleCheckboxClick || $[16] !== t11) {
    t12 = <div className="tw-flex-shrink-0 tw-self-start tw-mr-1" onClick={handleCheckboxClick}>{t11}</div>;
    $[15] = handleCheckboxClick;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== artWork) {
    t13 = artWork && <DropListItemContentMedia media_mime_type={artWork.mime_type} media_url={artWork.url} imageScale={ImageScale.AUTOx450} isCompetitionDrop={true} />;
    $[18] = artWork;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13) {
    t14 = <div className="tw-flex-shrink-0 tw-overflow-hidden tw-bg-iron-800 tw-min-h-[106px] tw-min-w-[106px] @md:tw-size-[106px] @xs:tw-w-full @xs:tw-h-56 @sm:tw-w-full @sm:tw-h-56 @sm:tw-mb-2 tw-relative"><div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-relative desktop-hover:hover:tw-scale-105 tw-transform tw-duration-300 tw-ease-out"><div className="tw-absolute tw-inset-0 tw-z-[1]">{t13}</div></div></div>;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== drop.rank) {
    t15 = drop.rank && <SingleWaveDropPosition rank={drop.rank} />;
    $[22] = drop.rank;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t15) {
    t16 = <div>{t15}</div>;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== drop.title) {
    t17 = <h3 className="tw-text-base tw-font-semibold tw-text-iron-50 tw-mb-0">{drop.title}</h3>;
    $[26] = drop.title;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t16 || $[29] !== t17) {
    t18 = <div className="tw-flex tw-flex-col @md:tw-flex-row @sm:tw-flex-col tw-gap-y-2 tw-gap-x-3">{t16}{t17}</div>;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== drop.author.pfp) {
    t19 = <div className="tw-size-6 tw-relative tw-flex-shrink-0 tw-rounded-md tw-overflow-hidden tw-ring-1 tw-ring-white/10 tw-bg-iron-800">{drop.author.pfp ? <img src={drop.author.pfp} alt="Profile" className="tw-h-full tw-w-full tw-object-contain tw-bg-iron-800" /> : <div className="tw-h-full tw-w-full tw-bg-iron-800 tw-rounded-md tw-ring-1 tw-ring-white/10" />}</div>;
    $[31] = drop.author.pfp;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  const t20 = drop.author.level || 0;
  let t21;
  if ($[33] !== cicType || $[34] !== t20) {
    t21 = <UserCICAndLevel level={t20} cicType={cicType} size={UserCICAndLevelSize.SMALL} />;
    $[33] = cicType;
    $[34] = t20;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  const t22 = drop.author.handle ?? drop.author.id;
  const t23 = `/${drop.author.handle}`;
  let t24;
  if ($[36] !== drop.author.handle) {
    t24 = e_0 => {
      e_0.stopPropagation();
      e_0.preventDefault();
      window.open(`/${drop.author.handle}`, "_blank");
    };
    $[36] = drop.author.handle;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] !== drop.author.handle || $[39] !== t23 || $[40] !== t24) {
    t25 = <Link href={t23} onClick={t24} className="tw-text-md tw-text-iron-200 desktop-hover:hover:tw-text-opacity-80 tw-transition-colors tw-duration-200 tw-no-underline desktop-hover:hover:tw-underline tw-font-medium tw-truncate">{drop.author.handle}</Link>;
    $[38] = drop.author.handle;
    $[39] = t23;
    $[40] = t24;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t22 || $[43] !== t25) {
    t26 = <UserProfileTooltipWrapper user={t22}>{t25}</UserProfileTooltipWrapper>;
    $[42] = t22;
    $[43] = t25;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] !== t19 || $[46] !== t21 || $[47] !== t26) {
    t27 = <div className="tw-flex tw-items-center tw-gap-2 tw-mt-4">{t19}{t21}{t26}</div>;
    $[45] = t19;
    $[46] = t21;
    $[47] = t26;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== drop) {
    t28 = <div onClick={_temp}><MyStreamWaveMyVoteVotes drop={drop} /></div>;
    $[49] = drop;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="tw-size-4 tw-text-iron-400 tw-flex-shrink-0"><path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" /></svg>;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== drop.raters_count) {
    t30 = <div className="tw-flex tw-items-center tw-gap-1.5">{t29}<span className="tw-text-sm tw-font-medium tw-text-iron-200">{drop.raters_count}</span></div>;
    $[52] = drop.raters_count;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] !== t28 || $[55] !== t30) {
    t31 = <div className="tw-flex tw-items-center tw-gap-x-6">{t28}{t30}</div>;
    $[54] = t28;
    $[55] = t30;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== drop || $[58] !== isResetting) {
    t32 = <div onClick={_temp2}><MyStreamWaveMyVoteInput drop={drop} isResetting={isResetting} /></div>;
    $[57] = drop;
    $[58] = isResetting;
    $[59] = t32;
  } else {
    t32 = $[59];
  }
  let t33;
  if ($[60] !== t31 || $[61] !== t32) {
    t33 = <div className="tw-flex tw-flex-col @lg:tw-flex-col @[42rem]:tw-flex-row tw-justify-between tw-gap-4 tw-mt-3.5 xl:tw-mt-3">{t31}{t32}</div>;
    $[60] = t31;
    $[61] = t32;
    $[62] = t33;
  } else {
    t33 = $[62];
  }
  let t34;
  if ($[63] !== t18 || $[64] !== t27 || $[65] !== t33) {
    t34 = <div className="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">{t18}{t27}{t33}</div>;
    $[63] = t18;
    $[64] = t27;
    $[65] = t33;
    $[66] = t34;
  } else {
    t34 = $[66];
  }
  let t35;
  if ($[67] !== t12 || $[68] !== t14 || $[69] !== t34) {
    t35 = <div className="tw-flex @md:tw-flex-row @sm:tw-flex-col @xs:tw-flex-col tw-gap-4">{t12}{t14}{t34}</div>;
    $[67] = t12;
    $[68] = t14;
    $[69] = t34;
    $[70] = t35;
  } else {
    t35 = $[70];
  }
  let t36;
  if ($[71] !== drop.id || $[72] !== handleClick || $[73] !== t35 || $[74] !== t8) {
    t36 = <div key={drop.id} className={t8} onClick={handleClick}>{t35}</div>;
    $[71] = drop.id;
    $[72] = handleClick;
    $[73] = t35;
    $[74] = t8;
    $[75] = t36;
  } else {
    t36 = $[75];
  }
  return t36;
};
export default MyStreamWaveMyVote;
function _temp(e_1) {
  return e_1.stopPropagation();
}
function _temp2(e_2) {
  return e_2.stopPropagation();
}